import { useState } from 'react';

export default function Documentation() {
  const [formData, setFormData] = useState({
    timeline: '',
    evidenceCollected: '',
    investigationSteps: '',
    findingsObservations: '',
    recommendedActions: '',
    lessonsLearned: '',
    additionalNotes: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="space-y-6 mt-6">
      <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <h3 className="text-lg font-medium leading-6 text-gray-900">Documentation</h3>
            <p className="mt-1 text-sm text-gray-500">
              Document all aspects of the incident investigation.
            </p>
          </div>
          <div className="mt-5 md:mt-0 md:col-span-2">
            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6">
                <label htmlFor="timeline" className="block text-sm font-medium text-gray-700">
                  Incident Timeline
                </label>
                <textarea
                  id="timeline"
                  name="timeline"
                  rows={4}
                  value={formData.timeline}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Document the sequence of events"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="evidenceCollected" className="block text-sm font-medium text-gray-700">
                  Evidence Collected
                </label>
                <textarea
                  id="evidenceCollected"
                  name="evidenceCollected"
                  rows={4}
                  value={formData.evidenceCollected}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="List and describe collected evidence"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="investigationSteps" className="block text-sm font-medium text-gray-700">
                  Investigation Steps
                </label>
                <textarea
                  id="investigationSteps"
                  name="investigationSteps"
                  rows={4}
                  value={formData.investigationSteps}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Detail the steps taken in the investigation"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="findingsObservations" className="block text-sm font-medium text-gray-700">
                  Findings & Observations
                </label>
                <textarea
                  id="findingsObservations"
                  name="findingsObservations"
                  rows={4}
                  value={formData.findingsObservations}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Document key findings and observations"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="recommendedActions" className="block text-sm font-medium text-gray-700">
                  Recommended Actions
                </label>
                <textarea
                  id="recommendedActions"
                  name="recommendedActions"
                  rows={4}
                  value={formData.recommendedActions}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="List recommended actions and next steps"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="lessonsLearned" className="block text-sm font-medium text-gray-700">
                  Lessons Learned
                </label>
                <textarea
                  id="lessonsLearned"
                  name="lessonsLearned"
                  rows={4}
                  value={formData.lessonsLearned}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Document lessons learned and improvements"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="additionalNotes" className="block text-sm font-medium text-gray-700">
                  Additional Notes
                </label>
                <textarea
                  id="additionalNotes"
                  name="additionalNotes"
                  rows={4}
                  value={formData.additionalNotes}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Any additional notes or comments"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}